enum PaymentProvider {
  Affirm = 'affirm',
  Stripe = 'stripe',
  GooglePay = 'googlePay',
  ApplePay = 'applePay',
}

export { PaymentProvider }
